import axios from '@plugins/axios';
/**
 * Composable function for making HTTP requests
 *
 * @param options - Client options
 * @returns Service composable with instantiated HTTP client
 */
export const useBaseService = (configuration) => {
    const client = axios(configuration);
    //* Base axios request, supplement with options
    const request = async (options) => {
        const response = await client(options).catch((error) => {
            if (error.response) {
                const errorMessage = {
                    ...error.response.status,
                    ...error.response.headers,
                    ...error.response.data
                };
                return Error("Request was made and server responded, but response fell out of range.", errorMessage);
            }
            else if (error.request) {
                return Error("The request was made but no response was received.", error.request);
            }
            else {
                return Error("Something happened in setting up the request that triggered an Error.", error.message);
            }
        });
        return response;
    };
    return {
        request,
    };
};
